import styled from "styled-components";

export const SSelectOrganizationStepList = styled.div`
  border-radius: 8px;
  overflow: hidden;
`;
